// src/sot/primitives/ProgressLine.jsx
import React from "react";

/**
 * AfriMed Linear Determinate Progress — Blueprint Accurate
 * - No background track (pure blue line only)
 * - Smooth animated width + shimmer accent
 * - Light/Dark adaptive, motion-safe
 */
export default function ProgressLine({ value = 0 }) {
  const pct = Math.max(0, Math.min(1, value)) * 100;
  const primary = "rgb(var(--afrimed-primary))";

  return (
    <div className="relative w-full h-[3px] overflow-hidden rounded-full">
      {/* Blue fill line */}
      <div
        className="absolute left-0 top-0 h-full rounded-full transition-[width] duration-700 ease-[cubic-bezier(0.25,0.8,0.25,1)]"
        style={{
          width: `${pct}%`,
          background: primary,
        }}
      />

      {/* Soft shimmer accent */}
      <div
        className="absolute top-0 h-full w-[48px]
                   bg-gradient-to-r from-transparent via-white/60 to-transparent
                   dark:via-white/30 opacity-80
                   motion-safe:animate-[afrimed_shimmer_1.6s_infinite]"
        style={{ left: `${pct - 4}%` }}
      />

      <style>{`
        @keyframes afrimed_shimmer {
          0% { transform: translateX(-120%); opacity: 0; }
          35% { opacity: .9; }
          100% { transform: translateX(120%); opacity: 0; }
        }
        @media (prefers-reduced-motion: reduce) {
          .motion-safe\\:animate-[afrimed_shimmer_1.6s_infinite] { animation: none !important; }
          .transition-\$begin:math:display$width\\$end:math:display$ { transition: none !important; }
        }
      `}</style>
    </div>
  );
}